import React from 'react'

// import moment from 'moment'

import db_lib from 'xAppLib/libs/db_lib';

import { WORDS_DICT } from "cont/words.js";

import GamesStatsSum from 'views/admin/games/GamesStatsSum'
import InListPopup from 'xAppLib/UIelems/InListPopup'

import Leaderboard from 'views/leaderboard/Leaderboard'


const _FRDB_LOC = 'games';
const _FRST_LOC = 'games';

const _DET_FIELDS = [

						{
							name: "name",
							label:'Game Name',
							type: "text",
							placeholder: "Enter a name for your game",
							param_name: "name",
							req_label: "*",
						},

						{
							name: "desc",
							label:'Description',
							type: "textarea",
							placeholder: "Describe your custom game",
							param_name: "desc",
							valid_not_required: true,
						},

						{
							name: "word",
							label:'The Word',
							type: "text",
							placeholder: "Choose random",
							param_name: "word",
							// req_label: "*",
							value: WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)],
							valid_not_required: true,
						},

						{
							name: "max_guesses",
							label:'Max Guesses',
							type: "number",
							size: 2,
							value: 6,
							valid_not_required: true,
						},

						{
							name: "dict",
							label:'Check Dictionary',
							type: "checkbox",
							options: [{c:'Yes', n:true}],
							valid_not_required: true,
						},

						{
							name: "public",
							label:'Public Leaderboard',
							type: "checkbox",
							options: [{c:'Allow anyone to view the leaderboard', n:true}],
							value: true,
							valid_not_required: true,
						},

						// {
						// 	name: "type",
						// 	label:'Type',
						// 	type: "radio",
						// 	options: [{c:'g', n:'Group'}, {c:'i', n:'Organisation'}],
						// 	placeholder: "Type?",
						// 	param_name: "t",
						// 	req_label: "*",
						// },

						// {
						// 	name: "code",
						// 	label:'Unique code',
						// 	type: "text",
						// 	placeholder: "Code",
						// 	pattern: "a-zA-Z0-9_-",
						// 	param_name: "c",
						// 	req_label: "*",
						// },

					];

const _LIST_FLDS_ADMIN = [
						{
							name: 'Num',
							type: 'multiline',
							lines: [
										{
											jpath: 'gnum',
										},
										{type: 'br'},
										{
											jpath: 'gid',
											type: 'i',
										},
									],
						},
						// {
						// 	name: 'Enabled',
						// 	jpath: 'enabled',
						// 	template : ({value:enabled}) => <React.Fragment>
						// 					<Icon name={enabled && 'check circle outline' || 'x'} color={enabled&&'green'||'red'} size='large'/>
						// 				</React.Fragment>
						// },

						{
							name: 'Added',
							type: 'multiline',
							lines: [
										{
											jpath: 'tm.seconds',
											jpath1: 'tm',
											type: 'time',
											frmt: "D/M/YY H:mm (ddd)"
										},
										// {type: 'br'},
										// {
										// 	jpath: 'tm_str',
										// },
										{type: 'br'},
										{
											type: 'compound',
											parts : [
												{
													name: 'tm_str',
													jpath: 'tm_str',
												},
											],
											template : ({tm_str}) => <React.Fragment>
															{tm_str?.match(/\(([^)]+)\)/)[1]}
															&nbsp;
															({tm_str?.match(/GMT([+-]\d{4})/)[1]})
															{/*{notes_model.TYPES[type]?.label || type}*/}
														</React.Fragment>
										},
									],
						},

						{
							name: 'Type',
							type: 'multiline',
							lines: [
										{
											jpath: 'type',
											type: 'b',
										},
										{type: 'br'},
										{
											jpath: 'name',
											type: 'b',
										},
										{type: 'br'},
										{
											jpath: 'desc',
											type: 'i',
										},
									],
						},

						// {
						// 	name: 'Type',
						// 	jpath: 'type',
						// 	template : ({value:type}) => <React.Fragment>
						// 					{type}
						// 					{/*{notes_model.TYPES[type]?.label || type}*/}
						// 				</React.Fragment>
						// },

						{
							name: 'By',
							type: 'multiline',
							lines: [
										{
											jpath: 'by.n',
										},
										{type: 'br'},
										{
											jpath: 'by.e',
										},
										{type: 'br'},
										{
											jpath: 'by.d',
										},
									],
						},

						{
							name: 'Game',
							type: 'multiline',
							lines: [
										{
											jpath: 'word',
											type: 'b',
										},
										{type: 'br'},
										{
											val: 'guesses:',
											type: 'val',
										},
										{
											jpath: 'max_guesses',
										},
										{type: 'br'},
										{
											val: 'dict:',
											type: 'val',
										},
										{
											jpath: 'dict',
											type: 'bool',
										},
									],
						},

						{
							name: 'Games stats',
							template: ({value: row}) => <GamesStatsSum icon='list' params={{ gid:row.gid }} />
						},

						{
							name: 'Games ldr',
							template: ({value: row}) => <InListPopup icon='list' Comp={Leaderboard} params={{ gid:row.gid, type:'admin' }} />
						},

					];
					


const _MODEL_NAME = 'game_model';

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

export default class game_model extends db_lib {

	static get FRDB_LOC() { return _FRDB_LOC; }
	static get FRST_LOC() { return _FRST_LOC; }
	static get DET_FIELDS() { return _DET_FIELDS; }
	static get MODEL_NAME() { return _MODEL_NAME; }

	static get LIST_FLDS_ADMIN() { return _LIST_FLDS_ADMIN; }

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

	static async get_game(gid, type) {

		let gdata = await game_model.get_record(gid, null, {flds:['name', 'desc', 'word', 'max_guesses', 'dict', 'public']});

		// console.log('gdata', gdata);

		if (!gdata && type === 'auto') {
			await game_model.set_game(gid, type);

			gdata = await game_model.get_record(gid, null, {flds:['name', 'desc', 'word', 'max_guesses', 'dict']});
		}


		return gdata
	}

// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

	static async set_game(gid = null, type, gdata = null) {

		if (!gdata && type == 'auto') {
			gdata = {
						game: 'wordle',
						type: 'auto',
						name: 'daily' + (gid&&(' 20' + gid.slice(6, 8) + '-' + gid.slice(8, 10) + '-' + gid.slice(10)) || ''),
						word: WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)],
						max_guesses: 7,
						dict: false,
						public: true,  // Daily games are always public
					}
		}

		if (gid) {
			await game_model.set_record(
					gid, 
					gdata, 
					{
						timestamp: true,
						add_by: true,
					}
				)
		} else {
			gid = await game_model.add_record(
					gdata, 
					{
						timestamp: true,
						add_by: true,
					}
				)
		}

		return gid
	}

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

	static async get_games_by_creator() {

		return await game_model.get_record(
			null,
			null,
			{
				fld: 'by.u',
				fld_val: app.user?.uid,
				fld2: 'type',
				fld2_val: 'set',

				add_id: 'gid',
				add_enum: 'gnum',
				ord_by: 'tm',
				ord_dir: 'desc'
			}
		);
	}

// ---- --------------------------------------------  --------------------------------------------
// ---- --------------------------------------------  --------------------------------------------

}